import React from 'react';

/**
 * ScreenBackground — now renders a clean warm white background.
 * All background photos & blur overlays have been removed per the UI redesign.
 */
export const ScreenBackground = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`min-h-screen ${className}`}
      style={{ background: 'var(--nuri-bg, #FDFBF7)' }}
      {...props}
    >
      {children}
    </div>
  );
};

export default ScreenBackground;
